import {
    useEmojiDropdownMenuState,
} from '@platejs/emoji/react';

import { emojiCategoryIcons, emojiSearchIcons } from './emoji-icons';
import { EmojiPicker } from './emoji-picker';
import {Popover} from "radix-ui";
import {ButtonWrapper} from "../_Button";
import FontAwesome from "../../../../utilities/FontAwesome";
import {useRef} from "react";
import styles from "./emoji.module.scss";

export function EmojiDropdownMenu() {
    const { emojiPickerState, isOpen, setIsOpen } =
        useEmojiDropdownMenuState();
    const triggerRef = useRef<HTMLButtonElement>(null);

    return <Popover.Root open={isOpen}>
        <Popover.Trigger asChild>
            <ButtonWrapper ref={triggerRef} onClick={() => setIsOpen(!isOpen)} tooltip="Emoji">
                <FontAwesome fixedWidth prefix={'far'} name={'fa-face-smile'}/>
            </ButtonWrapper>
        </Popover.Trigger>
        <Popover.Content
            className={styles.emojiPopoverContent}
            onPointerDownOutside={(e) => {
                if (triggerRef.current && !triggerRef.current.contains(e.target as HTMLElement)) {
                    setIsOpen(false);
                }
            }}
        >
            <EmojiPicker
                {...emojiPickerState}
                icons={{
                    categories: emojiCategoryIcons,
                    search: emojiSearchIcons,
                }}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            />
        </Popover.Content>
    </Popover.Root>
}
